import React from 'react'

const Card = (props) => {
  return (
    <h3 className='h1 mb-3 text-uppercase'>{props.title}</h3>
  )
}

export default Card